import z from 'zod'

export const loginSchema = z.object({
    email: z.string().email('Invalid email address').min(1, 'Email is required'),
    password: z.string().min(1, 'Password is required'),
    rememberMe: z.boolean().optional()
});

export const forgotPasswordSchema = z.object({
    email: z.string().email('Invalid email address').min(1, 'Email is required'),
})

export type LoginFormData = z.infer<typeof loginSchema>;
export type ForgotPasswordFormData = z.infer<typeof forgotPasswordSchema>;
